import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { useSignatureSources } from './useSignatureSources';

type UsePetitionInsightsReturn = ModelHookResult<{
	shouldShowPetitionInsights: boolean;
	shouldShowSignatureSources: boolean;
	shouldShowPromotionStats: boolean;
}>;

export function usePetitionInsights(): UsePetitionInsightsReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const { shouldShowSignatureSources } = useSignatureSources();

	const shouldShowPromotionStats = (petition.promotionStats?.promoterCount ?? 0) > 0;

	return {
		data: {
			shouldShowPetitionInsights: shouldShowPromotionStats || shouldShowSignatureSources,
			shouldShowSignatureSources,
			shouldShowPromotionStats,
		},
	};
}
